export enum Characteristic {
	Fluid = 'Fluid',
	SolidQuantifiable = 'SolidQuantifiable',
	SolidNonQuantifiable = 'SolidNonQuantifiable',
}
